
import { Button } from "@/components/ui/button";
import { FileIcon, FilesIcon } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { exportToCSV, exportToExcel, formatMembersForExport } from "../../utils/exportData";
import { Membership } from "../../utils/types";

interface ExportButtonsProps {
  members: Membership[];
}

export const ExportButtons = ({ members }: ExportButtonsProps) => {
  const handleExportToExcel = () => {
    if (members.length === 0) {
      toast({
        title: "Aucune donnée à exporter",
        description: "La liste des membres est vide.",
        variant: "destructive",
      });
      return;
    }
    
    try {
      const formattedData = formatMembersForExport(members);
      exportToExcel(formattedData, `membres_export_${new Date().toISOString().split('T')[0]}`);
      toast({
        title: "Export réussi",
        description: "Le fichier Excel a été téléchargé.",
      });
    } catch (error) {
      toast({
        title: "Erreur lors de l'export",
        description: "Impossible d'exporter les données vers Excel.",
        variant: "destructive",
      });
    }
  };
  
  const handleExportToCSV = () => {
    if (members.length === 0) {
      toast({
        title: "Aucune donnée à exporter",
        description: "La liste des membres est vide.",
        variant: "destructive",
      });
      return;
    }
    
    try {
      const formattedData = formatMembersForExport(members);
      exportToCSV(formattedData, `membres_export_${new Date().toISOString().split('T')[0]}`);
      toast({
        title: "Export réussi",
        description: "Le fichier CSV a été téléchargé.",
      });
    } catch (error) {
      toast({
        title: "Erreur lors de l'export",
        description: "Impossible d'exporter les données vers CSV.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Button 
        onClick={handleExportToExcel}
        variant="outline" 
        className="flex items-center gap-2"
        disabled={members.length === 0}
      >
        <FileIcon size={18} />
        Excel
      </Button>
      <Button 
        onClick={handleExportToCSV}
        variant="outline" 
        className="flex items-center gap-2"
        disabled={members.length === 0}
      >
        <FilesIcon size={18} />
        CSV
      </Button>
    </div>
  );
};
